<template>
  <div style="padding: 20px;">
    <Row>
      <Form inline :label-width="110">
        <FormItem label="筛选成员">
          <Select v-model="searchForm.phone" placeholder="选择成员" style="width:200px" filterable>
            <Option v-for="item in phoneList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="操作">
          <Button type="primary" @click="getList">查询</Button>
          <Button type="" @click="resetSearchForm" style="margin: 0 1rem">重置</Button>
        </FormItem>
      </Form>
    </Row>

    <Table border :columns="columns" :data="datas" style="margin-top: 15px;"></Table>
    <Page show-total :total="count" :page-size="pageSize" :current="page" @on-change="changePage" size="small"
          show-elevator />

  </div>
</template>

<script>
import {getList} from "@/api/verifyCodeRecord";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      searchForm: {
        phone: '',
      },
      count: 0,
      page: 1,
      pageSize: 20,
      datas: [],
      phoneList: [],
      columns: [
        {title: 'ID', key: 'id', width: 70, align: 'center'},
        {title: '手机号', key: 'phone', align: 'center'},
        {title: '姓名', key: 'name', align: 'center'},
        {title: '验证码', key: 'code', align: 'center'},
        {title: '有效期至', key: 'created_at', align: 'center'},
      ]
    };
  },
  computed: {...mapGetters(['token'])},
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      let res = await getList(this, {
        token: this.token,
        ...this.searchForm,
        page: this.page,
        pageSize: this.pageSize
      });
      console.log('res', res)
      if (res) {
        this.datas = res.data;
        this.count = res.total;
        this.phoneList = res.phoneList;
      }
    },
    resetSearchForm() {
      this.searchForm = {
        phone: '',
      }
      this.getList()
    },
    changePage(e) {
      this.page = e;
      this.getList();
    },
  }
};
</script>